module.exports = __webpack_public_path__ + "img/frame (84).0db0d25c.jpg";